<template>
  <section :class="isMobile ? 'repair-step mobile-repair-step' : 'repair-step'">
    <div class="title">客户问题确认（质检）</div>

    <div class="form">
      <root-cause-analyses-vue
        :rootCauseAnalyses="problemForm.afterSaleConfirm"
        ref="asi"
        :formdata="problemForm"
        title="售后问题确认"
        type="1"
        :disabled="!isEdit"
      >
      </root-cause-analyses-vue>

      <div class="df">
        <div class="step-label">成品检</div>
        <quality-inspection-vue
          ref="fpii"
          :echoList="problemForm.finishedProductProblem"
          :disabled="!isEdit"
        ></quality-inspection-vue>
      </div>

      <!-- <root-cause-analyses-vue
        :rootCauseAnalyses="problemForm.finishedProductProblem"
        ref="fpii"
        :formdata="problemForm"
        title="成品检问题"
        type="-1"
        :disabled="!isEdit"
      >
      </root-cause-analyses-vue> -->

      <div class="form-item">
        <a-space
          :size="isMobile ? 20 : 10"
          :direction="isMobile ? 'vertical' : 'horizontal'"
        >
          <div class="df vertical">
            <div class="step-label">完成时间</div>
            <div class="data">
              <select-day-vue
                :defaultVal="problemForm.completeDate"
                @userDelectDay="userDelectDay"
                :disabled="!isEdit"
              ></select-day-vue>
            </div>
          </div>
          <div class="df vertical">
            <div class="step-label">经手人</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.principal"
                placeholder="请输入经手人"
                allow-clear
                :disabled="!isEdit"
              ></a-input>
            </div>
          </div>
          <div class="df vertical" v-if="problemForm.rollbackReason">
            <div class="step-label">回退原因</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.rollbackReason"
                :disabled="true"
              ></a-input>
            </div>
          </div>
          <div class="df" v-if="problemForm.username">
            <div class="step-label">编辑人</div>
            <div class="data">
              {{ problemForm.username }}
            </div>
          </div>
        </a-space>
      </div>
    </div>

    <div class="footer df both-side">
      <a-button type="primary" @click="saveInfo" :disabled="!isEdit"
        >保存</a-button
      >
      <a-space :size="isMobile ? 10 : 50">
        <a-button @click="nextStep" :disabled="!isEdit">下一步</a-button>
        <a-button @click="backPreStep" type="danger" :disabled="!isEdit"
          >退回上一级</a-button
        >
      </a-space>
    </div>
  </section>

  <roll-back-modal-vue
    ref="rollBackModal"
    @rollBack="rollBack"
  ></roll-back-modal-vue>
</template>

<script>
import { defineComponent, reactive, ref, watch, computed } from "vue";
import {
  updateCustomerIssues,
  customerIssuesConfirm,
  customerIssuesRollback,
} from "@/request/view/repair";
import { Toast, showUploading, hideUploading } from "@/utils/index";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { showModal } from "../serve/modal";
import uploadImgVue from "./uploadImg.vue";
import uploadVideoVue from "./uploadVideo.vue";
import selectDayVue from "./selectDay.vue";
import rollBackModalVue from "./rollBackModal.vue";
import rootCauseAnalysesVue from "./contentDsc.vue";
import qualityInspectionVue from "./qualityInspection.vue";
// import qualityInspectionVue from "./qualityMaintenance.vue";

export default defineComponent({
  components: {
    uploadImgVue,
    uploadVideoVue,
    selectDayVue,
    rollBackModalVue,
    rootCauseAnalysesVue,
    qualityInspectionVue,
  },
  props: {
    progress: Object,
    machine: Object,
    meta: Object,
  },
  setup(props, context) {
    const store = useStore();
    const router = useRouter();
    const back = () => {
      // router.replace("/repairequipment");
      context.emit("back");
    };
    const isMobile = computed(() => store.state.isMonile);

    const problemForm = reactive({
      completeDate: null,
      principal: null,
      id: null,
      rollbackReason: null,
      repairEquipmentId: null,
      finishedProductProblem: null,
      afterSaleConfirm: null,
      userId: null,
      username: null,
    });

    const getEditLock = () => {
      const { id, username } = store.state.user.user;
      if (problemForm.userId === null && problemForm.username === null) {
        return true;
      } else if (problemForm.userId == id) {
        return true;
      }
      return false;
    };

    const isEdit = computed(() => {
      if (store.getters.user) {
        const unlock = getEditLock();
        return (
          props.meta["/qualityinspectionupdateInfo"] &&
          machineInfo.repairProcess == 1 &&
          unlock
        );
      }
      return false;
    });
    
    const uploadImg = ref();
    const uploadVideo = ref();
    const rollBackModal = ref();
    const asi = ref();
    const fpii = ref();
    const machineInfo = reactive({
      id: null,
      repairProcess: null,
    });

    const saveInfo = async () => {
      showUploading("上传中");
      // // 质检问题
      await fpii.value
        .saveQuality(problemForm.id)
        .then()
        .catch((err) => {
          hideUploading();
          throw new Error(err);
        });

      // 售后问题
      await asi.value
        .uploadContent()
        .then()
        .catch((err) => {
          console.log(err);
          hideUploading();
        });

      updateCustomerIssues({
        completeDate: problemForm.completeDate,
        id: problemForm.id,
        isEditable: problemForm.isEditable,
        principal: problemForm.principal,
        processRecords: problemForm.processRecords,
        repairEquipmentId: machineInfo.id,
        rollbackReason: problemForm.rollbackReason,
        userId: store.state.user.user.id,
        username: store.state.user.user.username,
        type: 1,
      })
        .then((res) => {
          context.emit("resetProcess");
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          problemForm.id = res.data.id;
          hideUploading();
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });
    };

    const nextStep = () => {
      showModal({
        title: "提示",
        toastText: "请先保存信息再确认到下一步流程？",
        success: () => {
          customerIssuesConfirm({
            customerIssuesId: problemForm.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200 && res.message === "成功") {
                context.emit("updateMachineInfo");
                context.emit("updateProcess", res.data);
                back();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const rollBack = (e) => {
      customerIssuesRollback({
        customerIssuesId: problemForm.id,
        rollbackReason: e,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          if (res.code === 200) {
            rollBackModal.value.handleCancel();
            context.emit("updateMachineInfo");
            // context.emit("updateProcess", res.data);
            back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const backPreStep = () => {
      rollBackModal.value.showModal();
      rollBackModal.value.setInputData(problemForm.rollbackReason);
    };

    const userDelectDay = (day) => {
      problemForm.completeDate = day;
    };

    const setProblemData = (data) => {
      problemForm.rollbackReason = data.rollbackReason;
      problemForm.principal = data.principal;
      problemForm.completeDate = data.completeDate;
      problemForm.id = data.id;
      problemForm.repairEquipmentId = data.repairEquipmentId;
      problemForm.finishedProductProblem = data.finishedProductProblem;
      problemForm.afterSaleConfirm = data.afterSaleConfirm;
      problemForm.userId = data.userId;
      problemForm.username = data.username;
    };

    watch(
      () => props.progress,
      (val) => {
        setProblemData(val);
      },
      {
        immediate: true,
        deep: true,
      }
    );
    watch(
      () => props.machine,
      (val) => {
        machineInfo.id = val.id;
        machineInfo.repairProcess = val.repairProcess;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      isMobile,
      machineInfo,
      problemForm,
      userDelectDay,
      saveInfo,
      nextStep,
      backPreStep,
      uploadImg,
      uploadVideo,
      rollBackModal,
      rollBack,
      isEdit,
      asi,
      fpii,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
